module.exports = __webpack_public_path__ + "img/zgw_question_creation.7389bfec.png";